import React, { useCallback } from 'react';
import DefaultMsgPage from '../../components/DefaultMsgPage';

const ErrorMessage: React.FC = () => {
  const handleRedirect = useCallback(async () => {
    window.location.replace('/minha-conta/alterar-senha');
  }, []);

  return (
    <>
      <DefaultMsgPage traductionKey="generic_error_screen" image="brokenSuitcase" onPrimary={handleRedirect} />
    </>
  );
};

export default ErrorMessage;
